<template>
  <div class="main">
    <ball></ball>
    <div class="nav">
      <Nav :title="'确认挂号'"></Nav>
    </div>
    <div class="body">
      <div class="head">
        <div class="datails_item_head">
          <div class="datails_item_title">就诊人:{{name}}</div>
        </div>
        <div class="icon_btn" @click="goconfirmuser()">
          <van-image
            fit="contain"
            :src="require('../../assets/img/switch.png')"
            height="27px"
            width="35px"
          ></van-image>
          <div class="datails_item_head_text">选择</div>
        </div>
      </div>
       <div class="datails_item">
        <div class="datails_item_title">预约医院</div>
        <div class="datails_item_text">{{hospname}}</div>
      </div>
       <div class="datails_item">
        <div class="datails_item_title">预约科室</div>
        <div class="datails_item_text">{{deptName}}</div>
      </div>
      <div class="datails_item" v-if="showdocname">
        <div class="datails_item_title">预约医生</div>
        <div class="datails_item_text">{{docName}}</div>
      </div>
       <div class="datails_item">
        <div class="datails_item_title">门诊类型</div>
        <div class="datails_item_text">{{regLevelName}}</div>
      </div>
      <div class="datails_item">
        <div class="datails_item_title">挂号费</div>
        <div class="datails_item_text">￥: {{regFee}}</div>
      </div>
      <div class="datails_item">
        <div class="datails_item_title">就诊时间</div>
        <div class="datails_item_text">{{show_date}}{{noonName}}</div>
      </div>
       <div class="datails_item" v-if="poptimelist&&poptimelist.length>0" @click="showTime=true">
        <div class="datails_item_title">选择时间段</div>
        <div class="datails_item_text">{{showpoptime}}</div>
      </div>
       <van-popup v-model="showTime" round position="bottom" :style="{ height: '40%'  }">
               <div class="poptime" >
                <van-button v-for="(item,index) in poptimelist" :key="index"
                small
                class="popbtn"
                  v-if="
                  new Date(show_date+ ' '  +item.endTime).getTime()>new Date().getTime()"
                @click="getPoptime(item)">
                {{item.startTime}}~{{item.endTime}}
                </van-button>
              </div>
    </van-popup>
     <!-- <div v-if="regFee!=0">
        <div class="datails_item">
        <div class="datails_item_title">支付方式</div>
      </div>
       <div>
       <div class="pay_item" v-for="(item,index) in paywaylist ">
        <div class="datails_item_title">{{item.payvalue}}</div>
      <van-radio-group v-model="radio" direction="horizontal">
      <van-radio :name=item.paykey></van-radio>
      </van-radio-group>
      </div>
       </div> 
     </div> -->
    </div>
    
    <div class="foot">
       <div class="details_BTn"> 
           <div class="btn">
          <van-button type="info" size="large" round :disabled="btnflag"  @click="schedulhead()">确认挂号</van-button>
        </div>
      </div>
    </div>
    </div>
    
  </div>
</template>

<script>
import Nav from "../../components/nav.vue";
import { Dialog } from "vant";
export default {
  data() {
    return {
      showdocname: false,
      docName: "",
      showTime: false,
      timer: null,
      vtypeflag: true,
      paywaylist: null,
      //展示的时间
      show_date: "",
      //医院名
      hospname: "",
      out_trade_no: "",
      //控制开关
      btnflag: false,
      //wx支付需要参数
      appId: "",
      timeStamp: "",
      nonceStr: "",
      package: "",
      signType: "",
      paySign: "",
      //
      radio: "wechat",
      //科室id
      deptId: "",
      //挂号级别id
      regLevelId: "",
      //就诊卡号
      clientId: "",
      //就诊人姓名
      name: "",
      //科室名
      deptName: "",
      //挂号费
      regFee: "",
      //挂号类型名
      regLevelName: "",
      //时间名
      noonName: "",
      // 看诊时间
      seeDate: "",
      //路由地址
      path: "",
      //挂号类型id
      regTypeId: "",
      //锁号类型id
      schedulId: "",
      //医院Id
      docId: "",
      //医生
      doctorId: "",
      version: "",
      //开始时间段
      popstarttime: "",
      popendtime: "",
      //
      showpoptime: "点击选择",
      poptimelist: [],
      popstarttime: "",
      popendtime: "",
      isdate: null,
      payWay: "",
    };
  },
  components: {
    Nav,
  },
  mounted() {
    this.getDetailsInfo();
    // this.beforeRouteEnter();
  },
  beforeRouteEnter(to, from, next) {
    // console.log(from.path);

    next((vm) => {
      // this.path= from.path
      vm.path = from.path;
      // console.log(vm.path);
    });
  },
  methods: {
    goconfirmuser() {
      this.$router.push({
        path: "/confirmuser",
        query: {
          ispath: "1",
        },
      });
    },
    //获取时间列表
    async getTimes() {
      try {
        this.$showLoad();
        let R_data = { noonName: this.noonName };
        let url = "/hospitalconf/getRegisterTime";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          R_data,
          (data) => {
            this.$hideLoad();
            this.poptimelist = data.data;
            // console.log(this.poptimelist[0].endTime)
            // console.log(this.poptimelist[0].startTime)
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    //选择时间
    getPoptime(item) {
      this.popstarttime = item.startTime;
      this.popendtime = item.endTime;
      this.showpoptime = this.popstarttime + "~" + this.popendtime;
      this.$local.set("popstarttime", this.popstarttime);
      this.$local.set("popendtime", this.popendtime);
      this.$local.set("showpoptime", this.showpoptime);
      this.showTime = false;
    },
    onBridgeReady(appId, timeStamp, nonceStr, pacKage, signType, paySign) {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: appId, //公众号名称，由商户传入
          timeStamp: timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: nonceStr, //随机串
          package: pacKage,
          signType: signType, //微信签名方式：
          paySign: paySign, //微信签名
        },
        (res) => {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            this.btnflag = true;
            Dialog.alert({
              title: "挂号成功",
              messageAlign: "left",
              message:
                "1.挂号信息只有预约挂号当天有效。\n2.挂号成功以后如需退费，挂号预约时间过后将不能线上退费，请到医院窗口退费。\n3.挂号后请按照预约时间到相应的科室直接进行就诊。\n4.需要发票请到院内门诊收费室挂号，在本界面点击取消。\n5.如需医保卡支付及报销请到院内收费窗口结算。",
            }).then(() => {
              this.$router.push({
                path: "/useRcorder",
                query: {
                  clientId: this.clientId,
                  name: this.name,
                },
              });
            });
            // this.$showLoad("支付确认中...");
            // this.timer = setTimeout(() => {
            //   this.$hideLoad();
            //   this.$router.push({
            //     path: "/useRcorder",
            //     query: {
            //       clientId: this.clientId,
            //       name: this.name,
            //     },
            //   });
            // }, 3000);
          }
        }
      );
    },
    async schedulhead() {
      if (this.poptimelist && this.poptimelist.length > 0) {
        if (this.showpoptime == "点击选择") {
          this.$toast.fail("未选择就诊时间段");
          return;
        }
      }
      let test = {
        docId: this.docId,
        clientId: this.clientId,
        regLevelId: this.regLevelId,
        noonId: this.noonId,
        seeDate: this.seeDate,
        regTypeId: this.regTypeId,
        schedulId: this.schedulId,
        deptName: this.deptName,
        deptId: this.deptId,
        regFee: this.regFee,
        payWay: this.payWay,
        select_poptime_start:this.popstarttime
      };
      try {
        if (!test.clientId) {
          Dialog.confirm({
            message: "请选择联系人",
            confirmButtonText: "前往",
            confirmButtonColor: "#5B8DF6",
          })
            .then(() => {
              this.$router.push({
                path: "/confirmuser",
                query: {
                  ispath: "1",
                },
              });
            })
            .catch(() => {
              // on cancel
            });
          return;
        }
        this.$showLoad("挂号确认中");
        let url = "/register/registerConfirm";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          test,
          (data) => {
            if (data.status == 400) {
              this.$hideLoad();
              this.$toast.fail("锁号失败，请前往收费室或联系管理员");
              return;
            }
            if (this.regFee == 0 && data.data.data.code == "1") {
              this.btnflag = true;
              this.$toast.success("挂号成功");
              this.timer = setTimeout(() => {
                this.$router.push({
                  path: "/useRcorder",
                  query: {
                    clientId: this.clientId,
                    name: this.name,
                  },
                });
              }, 3000);
              return;
            }
            this.$hideLoad();
            this.appId = data.data.data.appId;
            this.timeStamp = data.data.data.timeStamp;
            this.nonceStr = data.data.data.nonceStr;
            this.pacKage = data.data.data.package;
            this.signType = data.data.data.signType;
            this.paySign = data.data.data.paySign;
            // this.out_trade_no = data.data.data.out_trade_no;

            if (data.data.result == true) {
              this.$toast.success("锁号成功");

              if (data.data.needpay == true) {
                if (typeof WeixinJSBridge == "undefined") {
                  if (document.addEventListener) {
                    document.addEventListener(
                      "WeixinJSBridgeReady",
                      this.onBridgeReady(
                        this.appId,
                        this.timeStamp,
                        this.nonceStr,
                        this.pacKage,
                        this.signType,
                        this.paySign
                      ),
                      false
                    );
                  } else if (document.attachEvent) {
                    document.attachEvent(
                      "WeixinJSBridgeReady",
                      this.onBridgeReady(
                        this.appId,
                        this.timeStamp,
                        this.nonceStr,
                        this.pacKage,
                        this.signType,
                        this.paySign
                      )
                    );
                    document.attachEvent(
                      "onWeixinJSBridgeReady",
                      this.onBridgeReady(
                        this.appId,
                        this.timeStamp,
                        this.nonceStr,
                        this.pacKage,
                        this.signType,
                        this.paySign
                      )
                    );
                  }
                } else {
                  this.onBridgeReady(
                    this.appId,
                    this.timeStamp,
                    this.nonceStr,
                    this.pacKage,
                    this.signType,
                    this.paySign
                  );
                }
                this.$hideLoad();
              }
            } else {
              this.$toast.fail("锁号失败，请前往收费室或联系管理员");
              this.$hideLoad();
            }
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.isLoad = true;
      }
      // console.log(test);
    },
      formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    //获取参数
    getDetailsInfo() {
      this.getPayWay();
      if (this.path === "/schedulhead" || this.path === "/newschedulhead") {
        // console.log(this.$route.query.schedulheadInfo);
        this.deptName = this.$route.query.schedulheadInfo.deptName;
        // console.log(this.deptName);
        this.regFee = this.$route.query.schedulheadInfo.regFee;
        if (this.$route.query.schedulheadInfo.docName) {
          this.docName = this.$route.query.schedulheadInfo.docName;
          this.showdocname = true;
        } else {
          this.docName = "";
          this.showdocname = false;
        }

        // console.log(this.regFee);
        // console.log(this.vtypeflag);
        this.regLevelName = this.$route.query.schedulheadInfo.regLevelName;
        this.regLevelId = this.$route.query.schedulheadInfo.regLevelId;
        this.noonName = this.$route.query.schedulheadInfo.noonName;
        this.noonId = this.$route.query.schedulheadInfo.noonId;
        this.seeDate = this.$route.query.schedulheadInfo.seeDate;
       
        // if(this.$route.query.schedulheadInfo.doctorId){
        // this.doctorId=this.$route.query.schedulheadInfo.doctorId
        // }
        if (this.seeDate) {
          this.show_date = this.seeDate.substr(0, 10).replace(/-/g, '/');
           console.log(this.show_date)
        } else {
          this.show_date = "";
        }
        this.regTypeId = this.$route.query.schedulheadInfo.regTypeId;
        this.schedulId = this.$route.query.schedulheadInfo.schedulId;
        this.docId = this.$route.query.schedulheadInfo.docId;
        this.deptId = this.$route.query.schedulheadInfo.deptId;
        this.setLocalDetailsInfo();
        if (this.regFee == 0) {
          this.vtypeflag = false;
        } else {
          this.vtypeflag = true;
        }
      } else if (this.path === "/confirmuser") {
        this.deptName = this.$local.get("deptName");
        this.regFee = this.$local.get("regFee");
        this.regLevelName = this.$local.get("regLevelName");
        this.noonName = this.$local.get("noonName");
        this.schedulId = this.$local.get("schedulId");
        this.seeDate = this.$local.get("seeDate");
        this.regLevelId = this.$local.get("regLevelId");
        this.regTypeId = this.$local.get("regTypeId");
        this.noonId = this.$local.get("noonId");
        this.docId = this.$local.get("docId");
        this.deptId = this.$local.get("deptId");
        this.clientId = this.$route.query.clientId;
        this.name = this.$route.query.name;
        this.show_date = this.$local.get("show_date");
        // this.doctorId=this.$local.get("doctorId");
        this.version = this.$local.get("version");
        this.docName = this.$local.get("docName");
        this.popstarttime = this.$local.get("popstarttime", this.popstarttime);
        this.popendtime = this.$local.get("popendtime", this.popendtime);
        this.showpoptime = this.$local.get("showpoptime", this.showpoptime);
        if (this.docName) {
          this.showdocname = true;
        } else {
          this.showdocname = false;
        }
      }
      this.getTimes();
    },
    setLocalDetailsInfo() {
      let query = this.$route.query;
      // console.log(query.schedulheadInfo);
      if (query) {
        this.$local.set("seeDate", query.schedulheadInfo.seeDate.replace(/-/g, '/'));
        this.$local.set("noonId", query.schedulheadInfo.noonId);
        this.$local.set("version", this.version);
        this.$local.set("deptName", query.schedulheadInfo.deptName);
        this.$local.set("regFee", query.schedulheadInfo.regFee);
        this.$local.set("regLevelName", query.schedulheadInfo.regLevelName);
        this.$local.set("noonName", query.schedulheadInfo.noonName);
        this.$local.set("show_date", this.show_date);
        this.$local.set("regLevelId", query.schedulheadInfo.regLevelId);
        this.$local.set("regTypeId", query.schedulheadInfo.regTypeId);
        this.$local.set("schedulId", query.schedulheadInfo.schedulId);
        this.$local.set("deptId", query.schedulheadInfo.deptId);
        this.$local.set("docId", query.schedulheadInfo.docId);
        this.$local.set("show_date", this.show_date);
        this.$local.set("docName", this.docName);
      }
    },
    //获取支付方式列表
    async getPayWay() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/index/getPayType";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.$hideLoad();
            // console.log(data.data)
            this.paywaylist = data.data.objType;
            this.payWay = data.data.objType[0].paykey;
            console.log();
            this.hospname = data.data.hosp_name;
            this.version = data.data.version;
            let type = data.data.version;
            if (type == "D") {
              this.vtypeflag = false;
            } else {
              this.vtypeflag = true;
            }
            // console.log(this.vtypeflag);
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
  },
  //获取支付方式
  destroyed() {
    clearTimeout(this.timer);
  },
};
</script>

<style lang="scss">
.main {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f7f8fa;
  .body {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    .head {
      display: flex;
      width: 95%;
      margin: 0px auto;
      .datails_item_head {
        background-color: white;
        height: 50px;
        width: 85%;
        display: flex;
        justify-content: space-between;
        line-height: 50px;
      }
      .icon_btn {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        align-self: center;
        width: 18%;
        height: 50px;
        background-color: #5b8df6;
        .datails_item_head_text {
          color: white;
          font-size: 12px;
          font-size: 14px;
          line-height: 15px;
          height: 15px;
        }
      }
    }
    .datails_item {
      background-color: white;
      width: 95%;
      margin: 0px auto;
      margin-top: 5px;
      height: 45px;
      display: flex;
      justify-content: space-between;
      line-height: 45px;
    }
    .datails_item_title {
      font-size: 16px;
      color: #747d8c;
    }
    .datails_item_text {
      font-size: 16px;
      color: #747d8c;
    }
    .pay_item {
      background-color: white;
      width: 94%;
      margin: 0px auto;
      height: 45px;
      display: flex;
      justify-content: space-between;
      line-height: 45px;
    }
    .datails_item_title {
      font-size: 16px;
      color: #747d8c;
    }
    .datails_item_text {
      font-size: 16px;
      color: #747d8c;
    }
  }
  .poptime {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .popbtn {
      width: 50%;
    }
  }
  .foot {
    width: 100%;
    position: fixed;
    bottom: 10vh;
    margin: 0px auto;
    .details_BTn {
      width: 95%;
      margin: 0px auto;
      letter-spacing: 10px;
    }
  }
}
.van-button--round {
  border-radius: 10px;
}
</style>